/**
 * Estructura de routes de primer nivel
 *
 *   Solo deberíamos registrar el primer prefijo de la ruta
 * el resto se encarga otro.
 *
 * Si tenemos el modulo producción solo registramos
 *
 *   /produccion -> ModuloProducción
 *
 * Ese componente sabrá si hay más rutas o no, esto además nos permitirá dos cosas
 *
 *   - Mejorar la seguridad con los Permisos (no solo no mostramos rutas sino que no las cargamos)
 *   - Usar Lazy y Suspend para mejorar la performance
 *
 * OBS: El orden es importante en el matching
 *
 *    - path/
 *    - path/subpath    <- Nunca se va a ejecutar
 */

// import Dashboard from "./modulos/dashboard/index";

/**
 * La estructura debería ser de esta forma
 */
import authRoutes from './auth/routes'
import adminRoutes from './admin/routes'
import managerRoutes from './manager/routes'
import financeRoutes from './finance/routes'
import reportRoutes from './report/routes'
import vendorRoutes from './vendor/routes'
import commonRoutes from './common/routes'

export const APP_HOME = '/app/home'
// import HomeRoutes from "./modulos/home/";

const routes = [
  ...authRoutes,
  ...adminRoutes,
  ...managerRoutes,
  ...financeRoutes,
  ...reportRoutes,
  ...vendorRoutes,
  ...commonRoutes
]

export default routes
